export function mapNullToUndefined<T>(item: T | null) {
  return item ?? undefined;
}

export const flipMap = <T extends string, R extends string>(map: Record<T, R>) =>
  Object.fromEntries(Object.entries(map).map(([key, value]) => [value, key]));

export function replaceKeys<T, S>(obj: T, replaces: {[key: string]: string}): S {
  if (Array.isArray(obj)) {
    return obj.map((o) => replaceKeys(o, replaces)) as unknown as S;
  }
  if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [replaces[key] ? replaces[key] : key, replaceKeys(value, replaces)])
    ) as unknown as S;
  }
  return obj as unknown as S;
}
